import React, { JSX } from 'react';

// TODO Layout soweit anpassen, sodass diese Komponente überflüssig wird
export function PreviewImagePlaceholder(): JSX.Element {
  return <div style={{ width: '114px' }}></div>;
}
